module.exports = __webpack_public_path__ + "static/iso-logo-25e892aeb41bb74935cc1598f2767bda.png";